import { RibbonPlaceholder } from 'shared/components';

const RibbonPlaceholderWrapper = ({ repeat }) => {
  return [...Array(repeat)].map((e, i) => <RibbonPlaceholder key={i} />);
};

export default RibbonPlaceholderWrapper;
